// extracted by mini-css-extract-plugin
export default {"radio":"CardsTable_radio__yHzqw","radio__pick":"CardsTable_radio__pick__3JdLY","checkbox":"CardsTable_checkbox__C7VIp","checkbox__pick":"CardsTable_checkbox__pick__iXGS3"};